module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Pokaż pasek filtrowania"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sections"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": section.title_pl || 'Nowa sekcja',
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "section[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.text_color),
        callback: function($$v) {
          _vm.$set(section, "text_color", $$v)
        },
        expression: "section.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Typ kafla",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tile_type']
      }
    }, _vm._l((_vm.availableTileTypes), function(type) {
      return _c('el-radio', {
        key: type.value,
        attrs: {
          "label": type.value,
          "border": "",
          "size": "medium"
        },
        model: {
          value: (section.tile_type),
          callback: function($$v) {
            _vm.$set(section, "tile_type", $$v)
          },
          expression: "section.tile_type"
        }
      }, [_c('img', {
        staticClass: "tile",
        attrs: {
          "src": type.imgSrc,
          "alt": type.label
        }
      })])
    }), 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tagi",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tags']
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": "Wybierz tagi"
      },
      model: {
        value: (section.tags),
        callback: function($$v) {
          _vm.$set(section, "tags", $$v)
        },
        expression: "section.tags"
      }
    }, _vm._l((_vm.tags), function(option) {
      return _c('el-option', {
        key: option.id,
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ sekcja")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ddcd75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/EventsListWidget.vue
// module id = 770
// module chunks = 0